export default __webpack_public_path__ + "static/media/237.bb931da7.jpg";